import { useEffect, useRef } from 'react';

/**
 * Custom hook to detect ?gold keyboard sequence
 * @param {Function} onSequenceDetected - Callback when ?gold is typed
 */
function useFeatureToggleShortcut(onSequenceDetected) {
  const keySequenceRef = useRef([]);
  const targetSequence = '?gold';

  useEffect(() => {
    const handleKeyPress = (event) => {
      // Add the pressed key to the sequence
      keySequenceRef.current.push(event.key.toLowerCase());

      // Keep only the last 5 characters (length of '?gold')
      if (keySequenceRef.current.length > targetSequence.length) {
        keySequenceRef.current.shift();
      }

      // Check if the sequence matches '?gold'
      const currentSequence = keySequenceRef.current.join('');
      if (currentSequence === targetSequence) {
        onSequenceDetected();
        // Reset the sequence after detection
        keySequenceRef.current = [];
      }
    };

    // Add event listener
    window.addEventListener('keypress', handleKeyPress);

    // Cleanup
    return () => {
      window.removeEventListener('keypress', handleKeyPress);
    };
  }, [onSequenceDetected]);
}

export default useFeatureToggleShortcut;
